<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'GeneralError',
    beforeRouteEnter(to, from, next) {
      window.previousRoute = from
      next()
    },
    computed: {
      generalTitle() {
        return this.$route.query.title || this.$t('page_errors.general.title')
      },
      generalDescription() {
        return this.$route.query.error || this.$route.query.description || this.$t('page_errors.general.description')
      },
    },
    methods: {
      routeBack() {
        const route = window.previousRoute || { name: 'dashboard' }
        this.$router.push(route)
      },
    },
  }
</script>
